<template>
    <el-autocomplete
        v-if="permissionsShow"
        :placeholder="placeholder"
        :disabled="disabled"
        :value-key="valueKey"
        v-model="currentValue"
        :debounce="debounce"
        :placement="placement"
        :fetch-suggestions="fetchSuggestions"
        :popper-class="popperClass"
        :trigger-on-focus="triggerOnFocus"
        :name="name"
        :select-when-unmatched="selectWhenUnmatched"
        :label="label"
        :prefix-icon="prefixIcon"
        :suffix-icon="suffixIcon"
        :hide-loading="hideLoading"
        :popper-append-to-body="popperAppendToBody"
        :style="{ width: width + 'px' }"
        @select="select"
        ref="autocompleteRef"
    >
        <template slot="prepend" v-if="$slots.prepend">
            <slot name="prepend"></slot>
        </template>
        <template slot="append" v-if="$slots.append">
            <slot name="append"></slot>
        </template>
        <template slot="prefix" v-if="$slots.prefix">
            <slot name="prefix"></slot>
        </template>
        <template slot="suffix" v-if="$slots.suffix">
            <slot name="suffix"></slot>
        </template>
        <template slot-scope="{ item }">
            <slot :item="item"></slot>
        </template>
    </el-autocomplete>
</template>

<script>
export default {
    props: {
        /* 输入框占位文本 */
        placeholder: String,
        /* disabled */
        disabled: Boolean,
        /* 输入建议对象中用于显示的键名 */
        valueKey: {
            type: String,
            default: 'value'
        },
        /* 必填值，输入绑定值 */
        value: String,
        /* 获取输入建议的去抖延时 */
        debounce: {
            type: Number,
            default: 300
        },
        /* 菜单弹出位置 top / top-start / top-end / bottom / bottom-start / bottom-end */
        placement: {
            type: String,
            default: 'bottom-start'
        },
        /* 返回输入建议的方法，仅当你的输入建议数据 resolve 时，通过调用 callback(data:[]) 来返回它 */
        fetchSuggestions: Function,
        /* Autocomplete 下拉列表的类名 */
        popperClass: String,
        /* 是否在输入框 focus 时显示建议列表 */
        triggerOnFocus: {
            type: Boolean,
            default: true
        },
        /* 原生属性 */
        name: String,
        /* 在输入没有任何匹配建议的情况下，按下回车是否触发 select 事件 */
        selectWhenUnmatched: {
            type: Boolean,
            default: false
        },
        /* 输入框关联的label文字 */
        label: String,
        /* 输入框头部图标 */
        prefixIcon: String,
        /*输入框尾部图标  */
        suffixIcon: String,
        /* 是否隐藏远程加载时的加载图标 */
        hideLoading: Boolean,
        /* 是否将下拉列表插入至 body 元素。在下拉列表的定位出现问题时，可将该属性设置为 false */
        popperAppendToBody: {
            type: Boolean,
            default: true
        },
        /* 宽度设置 */
        width: {
            type: [Number, String],
            default: function() {
                return 200;
            }
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    created() {
        this.currentValue = this.value;
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true,
            currentValue: String
        };
    },
    watch: {
        value(val) {
            this.currentValue = val;
        }
    },
    methods: {
        /* 点击选中建议项时触发 */
        select(val) {
            this.$emit('select', val);
            this.$emit('input', val[this.valueKey]);
        },
        /* 使 input 获取焦点 */
        focus() {
            this.$refs.autocompleteRef.focus();
        }
    }
};
</script>
